import Enumerable from "linq";
import { Directory } from ".";

export class RootDirectory<TKey, TEntity> {
  constructor(public nodes: Directory<TKey, TEntity>[], public entities: TEntity[]) {
  }

  clone(): RootDirectory<TKey, TEntity> {
    return new RootDirectory<TKey, TEntity>(
      Enumerable.from(this.nodes).select(n => n.clone()).toArray(),
      Enumerable.from(this.entities).select(e => this.cloneInstance<TEntity>(e)).toArray()
    );
  }

  private cloneInstance<T>(source: T): T {
    return this.cloneAnyInstance(source) as T;
  }

  private cloneAnyInstance(source: any): any {
    return (source && source.clone !== undefined)
      ? source.clone()
      : source;
  }
}
